import React, { createContext, useMemo, useState } from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export default function ThemeContextProvider({ children }) {
  const [mode, setMode] = useState(localStorage.getItem("theme") || "light");

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => {
          const newMode = prevMode === "light" ? "dark" : "light";
          localStorage.setItem("theme", newMode);
          return newMode;
        });
      },
    }),
    []
  );

  // 2026-10-22 fix — same real bug confirmed on labariumaireport's
  // identical ThemeContext.js: with no explicit `primary` color, MUI's
  // dark-mode default (a light blue, #90caf9) auto-computes DARK
  // contrastText, but this app's own "contained" buttons override their
  // background via sx to the brand's dark navy — which doesn't lighten in
  // dark mode — leaving near-black text on a dark navy button. Pinning
  // `primary` to the brand navy in both modes makes MUI's auto-contrast
  // correctly resolve to white.
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: { main: "#00357a", contrastText: "#ffffff" },
        },
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
